import { Box } from "@mui/material"
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation"
import React from "react"
import { playerStore } from "src/store/PlayerStore"

import useTranslate from "../../../../hooks/use-translate"
import { s } from "../../../../utilities/common"
import { theme } from "../../../../utilities/theme"

export const StreamQualityButton = ({ focusKey }: { focusKey?: string }) => {
  const t = useTranslate()
  const setStreamingQualityOpen = playerStore(
    (state) => state.setStreamingQualityOpen,
  )

  const onPress = () => {
    setStreamingQualityOpen(true)
  }

  const { focused, ref, focusSelf } = useFocusable({
    focusKey,
    onEnterPress: onPress,
  })

  return (
    <Box
      sx={{ height: s("72px"), width: s("72px") }}
      tabIndex={0}
      aria-label={t("audio_quality")}
      onMouseEnter={() => focusSelf({ noScroll: true })}
      onMouseDown={onPress}
      ref={ref}
    >
      <svg
        width={s("72")}
        height={s("72")}
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="36"
          cy="36"
          r="36"
          fill={focused ? "white" : theme.palette.new.playerButton}
        />
        <path
          d="M28.7109 6.57715C28.7109 6.86035 28.6279 7.10449 28.4619 7.30957C28.2959 7.51465 28.0762 7.64648 27.8027 7.70508L21.4014 9.11133C21.1182 9.16992 20.9424 9.24316 20.874 9.33105C20.8057 9.41895 20.7715 9.62402 20.7715 9.94629V22.6465C20.7715 23.623 20.6055 24.4678 20.2734 25.1807C19.9512 25.9033 19.5215 26.499 18.9844 26.9678C18.457 27.4365 17.8809 27.7832 17.2559 28.0078C16.6309 28.2422 16.0205 28.3594 15.4248 28.3594C14.2041 28.3594 13.2031 27.998 12.4219 27.2754C11.6504 26.5625 11.2646 25.6396 11.2646 24.5068C11.2646 23.3838 11.6162 22.4561 12.3193 21.7236C13.0225 20.9912 14.0967 20.4785 15.542 20.1855L17.7686 19.7168C18.2959 19.6094 18.5352 19.2578 18.4863 18.6621L18.4717 3.3252C18.4717 2.45605 18.9795 1.90918 19.9951 1.68457L27.1582 0.117188C27.5781 0.0390625 27.9395 0.126953 28.2422 0.380859C28.5547 0.625 28.7109 0.961914 28.7109 1.3916V6.57715ZM1.04004 7.22168C0.74707 7.22168 0.498047 7.11914 0.292969 6.91406C0.0976562 6.70898 0 6.46973 0 6.19629C0 5.91309 0.0976562 5.66895 0.292969 5.46387C0.498047 5.25879 0.74707 5.15625 1.04004 5.15625H13.2861C13.5596 5.15625 13.7988 5.25879 14.0039 5.46387C14.209 5.66895 14.3115 5.91309 14.3115 6.19629C14.3115 6.46973 14.209 6.70898 14.0039 6.91406C13.7988 7.11914 13.5596 7.22168 13.2861 7.22168H1.04004ZM1.04004 12.1436C0.74707 12.1436 0.498047 12.0459 0.292969 11.8506C0.0976562 11.6455 0 11.4014 0 11.1182C0 10.835 0.0976562 10.5957 0.292969 10.4004C0.498047 10.2051 0.74707 10.1074 1.04004 10.1074H13.2861C13.5596 10.1074 13.7988 10.2051 14.0039 10.4004C14.209 10.5957 14.3115 10.835 14.3115 11.1182C14.3115 11.4014 14.209 11.6455 14.0039 11.8506C13.8086 12.0459 13.5693 12.1436 13.2861 12.1436H1.04004ZM1.04004 17.0947C0.74707 17.0947 0.498047 16.9971 0.292969 16.8018C0.0976562 16.5967 0 16.3525 0 16.0693C0 15.7861 0.0976562 15.542 0.292969 15.3369C0.498047 15.1318 0.74707 15.0293 1.04004 15.0293H13.2861C13.5596 15.0293 13.7988 15.1318 14.0039 15.3369C14.209 15.542 14.3115 15.7861 14.3115 16.0693C14.3115 16.3525 14.209 16.5967 14.0039 16.8018C13.8086 16.9971 13.5693 17.0947 13.2861 17.0947H1.04004Z"
          transform="translate(22, 22)"
          fill={focused ? theme.palette.new.playerButton : "white"}
        />
      </svg>
    </Box>
  )
}
